import { SportsEvent } from 'schema-dts'
import dayjs from 'dayjs'
import { MatchClientModel } from '@sport1/types/sportData'
import { LabelProps, TagProps } from '@sport1/types/web'
import SportEventStatus from '@/components/LinkedData/SportEventStatus'
import { slugify } from '@/helpers/slugHelper'
import Config from '@/utils/Config'
import { getMatchLivetickerHref } from '@/utils/navigation/Navigator'

export default function getTeamSportsEventByMatch(
    match: MatchClientModel,
    tag?: TagProps | LabelProps
): SportsEvent {
    const url = getMatchLivetickerHref({ match, tag }) || location.href

    return {
        '@type': 'SportsEvent',
        url,
        name: `${match.homeTeam?.shortName} - ${match.awayTeam?.shortName}, ${match.roundTitle}`,
        description: `${match.competition?.name} - ${match.season?.name}: Am ${dayjs(
            match.scheduledStartTime
        )
            .tz()
            .format('DD.MM.YYYY')} um ${dayjs(match.scheduledStartTime)
            .tz()
            .format('HH:mm')} Uhr spielt ${match.homeTeam?.name} zu Hause gegen ${match.awayTeam
            ?.name}. Austragungsort ist ${match.venue?.city}, ${match.venue?.name}.`,
        startDate: match.actualStartTime || match.scheduledStartTime,
        eventStatus: SportEventStatus[`${match.period}`] || SportEventStatus.DEFAULT,
        homeTeam: {
            '@type': 'SportsTeam',
            name: match.homeTeam?.name,
            sameAs: `${Config.HOST}/team/${slugify(match.homeTeam?.name || 'unknown')}/${match
                .homeTeam?.id}`,
        },
        awayTeam: {
            '@type': 'SportsTeam',
            name: match.awayTeam?.name,
            sameAs: `${Config.HOST}/team/${slugify(match.awayTeam?.name || 'unknown')}/${match
                .awayTeam?.id}`,
        },
        location: {
            '@type': 'StadiumOrArena',
            name: match.venue?.name,
            image: `https://reshape.sport1.de/c/s/teams/${match.homeTeam?.id}/50x50`,
            maximumAttendeeCapacity: match.venue?.capacity,
            address: { '@type': 'PostalAddress', name: match.venue?.city },
        },
    }
}
